import {observer} from 'mobx-react-lite'
import * as React from 'react'
import {Lang} from 'yougile-lang'
import {Button} from '@components/common/base/buttons'
import {repeatStore} from './repeat-store'

export const RepeatEditFooter = observer(() => {
  if (!repeatStore.editedTpl) {
    return null
  }

  const canBeSaved =
    !!repeatStore.hasChanged && repeatStore.state.scheduleEditFormValid

  return (
    <div className="flex justify-end w-full">
      <Button
        onClick={repeatStore.saveCurrent}
        disabled={!canBeSaved}
        className="mx-16"
      >
        {Lang.msg.save}
      </Button>
    </div>
  )
})
